import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import {Box, LinearProgress, Tooltip} from "@mui/material";
import {useState} from "react";
import LoginToken from "../../../../local_storage/LoginToken";

async function removeOrganization(organization_id, accessToken) {
    return fetch(`${process.env.REACT_APP_SERVER_URL}/organization`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': accessToken,
        },
        body: JSON.stringify({organization_id})
    }).then(data => data.json())
}

export default function SuperAdminDeleteOrganizationAlertDialog({organizationToRemove, organizations, setOrganizations, rerender}) {
    let {getToken} = LoginToken();
    const [open, setOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        setSaving(true);
        removeOrganization(organizationToRemove.organization_id, getToken()?.token).then(result => {
            if(result?.state) {
                let indexToDelete = organizations.findIndex(org => org.organization_id === organizationToRemove.organization_id);
                let newArray = [...organizations];
                newArray.splice(indexToDelete, 1);
                setOrganizations(newArray);
                setOpen(false);
                setSaving(false);
                rerender(true);
            } else {
                setError(result?.error ? result.error : 'Error on removing user.');
                setSaving(false);
            }
        })
    };

    return (
        <Box sx={{display:'flex', alignItems:'center', justifyContent:'end'}} pr={1}>
            <Tooltip title={`Delete ${organizationToRemove.organization_name}`}>
                <RemoveCircleOutlineIcon sx={{fontSize:16}} cursor={'pointer'} color={'error'} onClick={handleClickOpen}/>
            </Tooltip>


            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                { saving && <LinearProgress/> }
                <DialogTitle id="alert-dialog-title">
                    Delete Organization
                </DialogTitle>
                <DialogContent>
                    <DialogContentText color={'error'}>{error}</DialogContentText>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete <b>{organizationToRemove.organization_name}</b>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={saving}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus disabled={saving}>DELETE</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
